import { Directive, ViewContainerRef, Input } from '@angular/core';

@Directive({
  selector: '[title]'
})
export class StepperDirective {

  @Input('title') title: any;

  constructor() {
  }

  ngOnInit() {
  }

}
